export const TBD = "À compléter";

// Configuration légale centrale : remplacer TBD par les valeurs confirmées.
export const LEGAL = {
  serviceName: "Safe Start",
  brand: "doli.nc",
  territory: "Nouvelle-Calédonie",
  companyName: TBD,
  legalForm: TBD,
  capital: TBD,
  ridet: TBD,
  rcs: TBD,
  address: TBD,
  representative: TBD,
  publicationManager: TBD,
  phone: TBD,
  contactEmail: TBD,
  privacyEmail: TBD,
  securityEmail: TBD,
  host: TBD,
  hostAddress: TBD,
  hostLocation: TBD,
  currentPlatform: "Emergent",
};

export const LEGAL_UPDATED = "2026-10-22";

export const DOC_VERSIONS = {
  "centre-aide": "1.0", "securite-confiance": "1.0", contact: "1.0", "a-propos": "1.0",
  confidentialite: "0.1 (projet)", cookies: "0.1 (projet)", "sous-traitants": "0.1 (projet)", dpa: "0.1 (présentation)",
  "mentions-legales": "0.1 (projet)", cgu: "0.1 (projet)", "conditions-commerciales": "0.1 (projet)",
  "signalement-vulnerabilite": "1.0",
};

export const isSet = (v) => Boolean(v) && v !== TBD;

export const publisherLabel = () => (isSet(LEGAL.companyName)
  ? LEGAL.companyName
  : `l'éditeur du service ${LEGAL.serviceName} (raison sociale ${TBD})`);

export const LAW_NC = "conformément à la loi Informatique et Libertés et aux dispositions du RGPD telles que rendues applicables en Nouvelle-Calédonie";
